// Filtrage par statut, partagé entre la liste des documents et la légende cliquable.
// « Envoyé(e) » couvre envoye et envoyee ; « Confirmée » couvre confirmee, validee et en_cours.
export const matchesStatusFilter = (doc, filter) => {
  if (!filter) return true;
  if (filter === "payee_sent") return doc.status === "payee" && doc.is_sent;
  if (filter === "payee_not_sent") return doc.status === "payee" && !doc.is_sent;
  if (filter === "envoye") return doc.status === "envoye" || doc.status === "envoyee";
  if (filter === "envoyee") return doc.status === "envoyee";
  if (filter === "confirmee") return ["confirmee", "validee", "en_cours"].includes(doc.status);
  return doc.status === filter;
};
